var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status column",class:_vm.issue.status},[(_vm.issue.status === _vm.issueStatuses.FIXED)?_c('v-icon',[_vm._v("check")]):_vm._e(),_c('span',{staticClass:"status-name"},[_vm._v(_vm._s(_vm.$t(_vm.calculatedStatusName)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }